import React from 'react';
import Navbar from'./view components/Navbar';
import Home from './view components/Home';
import Services from './view components/Services';
import Team from './view components/Team';
import ContactUs from './view components/ContactUs';
import AboutUs from './view components/AboutUs';
import Footer from './view components/Footer';
import {BrowserRouter as Router,Route,Routes } from 'react-router-dom';
import TeamCard from './components/TeamCard';
import './App.css';
import QRMenu from './view components/QRMenuDemo';

function App() {
  return (
 <Router>
<div class="App">

{<Routes>
<Route path="/" element={<><Navbar/>
<Home/>
<Services />
<Team />
<AboutUs />
<ContactUs /> 
<Footer/> </> }/>

<Route path="/qrDemo" element={<QRMenu />}/> 
</Routes>  }

</div>
</Router> 

  );
}

export default App;

{/* <Services />
<Navbar/>
<Home/>
<Team />
<AboutUs />
<ContactUs /> 
 <Footer/>*/}